import { DateRangeField, Label, PageTabsContent, SearchInput, VirtualizedDataTable } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { useActivityTabContent } from "./useActivityTabContent";

export interface ActivityTabContentProps {
  userId?: string;
}

export const ActivityTabContent = ({ userId }: ActivityTabContentProps) => {
  const { t } = useTranslation("settings");
  const {
    columns,
    logs,
    dateRange,
    setDateRange,
    recordId,
    setRecordId,
    onLoadMore,
    hasMoreData,
    isLoadingMore,
    isEmpty,
  } = useActivityTabContent({ userId });

  return (
    <PageTabsContent
      value="activity"
      className="px-6 py-4 space-y-2 overflow-y-auto"
      style={{
        maxHeight: "min(80vh, 900px)",
      }}
    >
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>{t("Date Range")}</Label>
          <DateRangeField label="" value={dateRange} onChange={setDateRange} className="h-9" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="recordId">{t("Search Record ID")}</Label>
          <SearchInput
            id="recordId"
            value={recordId}
            onChange={(e) => setRecordId(e.target.value)}
            placeholder={t("Enter record ID")}
          />
        </div>
      </div>
      <VirtualizedDataTable
        data={logs}
        columns={columns}
        getRowId={(row) => row.id}
        enableSorting={false}
        enableSearch={false}
        onLoadMore={onLoadMore}
        hasMoreData={hasMoreData}
        isLoadingMore={isLoadingMore}
        isEmpty={isEmpty}
        height={360}
        headerClassName="bg-gray-50"
      />
    </PageTabsContent>
  );
};
